import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AttendanceRecordService } from 'app/services/attendance-record-service';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { memo } from '../../helpers/helper';
import { SchoolActivityInstance, User } from '../../models';
import { AttendanceRecord, AttendanceRecordState } from '../../models/AttendanceRecord';
import { SelectOption } from './starlight-select.component';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-attendee-student',
	template: `
		<div class="ta-student-item">
			<img [src]="student.profile_picture ? student.profile_picture : './assets/Default Avatar.png'" alt="profile picture" />
			<span>{{ student.display_name }}</span>
			<div *ngIf="showAttendance" class="attendance-container">
				<span class="late-time" *ngIf="attendanceRecord?.state === stateEnum.LateNotExcused">{{
					attendanceRecord && attendanceRecord.updated_at && formatLateTime(attendanceRecord.updated_at)
				}}</span>
				<sp-starlight-select
					[options]="selectOptions"
					[selected]="selectedOption"
					[placeholder]="placeholder"
					(onSelect)="selectOption($event)"></sp-starlight-select>
			</div>
			<div *ngIf="!showAttendance" class="check" (click)="checkClicked.emit()"></div>
		</div>
	`,
	styleUrls: ['./attendee-student.component.scss'],
})
export class AttendeeStudentComponent implements OnChanges {
	@Input() student!: User;
	@Input() attendanceRecord?: AttendanceRecord | null = null;
	@Input() showAttendance = false;
	@Input() activityInstance!: SchoolActivityInstance;
	@Output() checkClicked = new EventEmitter<void>();

	stateEnum = AttendanceRecordState;
	selectedOption: SelectOption<string | void>;
	placeholder: SelectOption<void> = { display: 'Select', textColor: '#7083A0', backgroundColor: '#F0F2F5', value: void 0 };
	selectOptions: SelectOption<string | void>[] = [
		{
			display: 'Present',
			textColor: '#00B476',
			backgroundColor: '#E5F7F1',
			value: this.stateEnum.Present,
		},
		{
			display: 'Absent',
			textColor: '#E32C66',
			backgroundColor: '#FCE9EF',
			value: this.stateEnum.Absent,
		},
		{
			display: 'Late, Excused',
			textColor: '#72CC1B',
			backgroundColor: '#F0F9E8',
			value: this.stateEnum.LateExcused,
		},
		{
			display: 'Late, Unexcused',
			textColor: '#E48C15',
			backgroundColor: '#FCF3E7',
			value: this.stateEnum.LateNotExcused,
		},
	];

	constructor(protected attendanceRecordService: AttendanceRecordService) {
		this.selectedOption = this.placeholder;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.attendanceRecord && !!changes.attendanceRecord.currentValue) {
			this.setSelectedOption(changes.attendanceRecord.currentValue);
		}
	}

	setSelectedOption(a: AttendanceRecord) {
		const option = this.selectOptions.find((o) => o.value == a.state);
		if (option) {
			this.selectedOption = option;
		}
	}

	selectOption(o: SelectOption<string | void>) {
		this.selectedOption = o;
		if (this.attendanceRecord && o.value) {
			void firstValueFrom(this.attendanceRecordService.updateRecordState({ id: this.attendanceRecord.id, state: o.value }));
		}
	}

	formatLateTime = memo((time: Date) => {
		return moment(time).format('h:mm a');
	});
}
